// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__3f7rT","col":"Table_col__2g2-Y","fulfillmentStatus":"Table_fulfillmentStatus__1nx5F","emailCol":"Table_emailCol__1yPHQ"};